const ANALYTICS_TYPES = {
	NAPI_USER_ONBOARDING_FAILED: 'napi.user.onboarding.failed',
	NAPI_USER_PROFILE_MODIFICATION_FAILED:
		'napi.user.profile.modification.failed',
	NAPI_USER_PROFILE_MODIFICATION_CANCELLED:
		'napi.user.profile.modification.cancelled',
	NAPI_USER_PROFILE_PICTURE_UPLOADING_FAILED:
		'napi.user.profile.picture.uploading.failed',
	NAPI_USER_ONBOARDED: 'napi.user.onboarded',
	NAPI_BUILDERS_PROFILE_MODAL_MOUNT: 'napi.builders.profile.modal.mount',
	NAPI_BUILDERS_PROFILE_MODAL_UNMOUNT: 'napi.builders.profile.modal.unmount',
	NAPI_BUILDERS_PROFILE_EDIT_PROFILE_CLICKED:
		'napi.builders.profile.edit.profile.clicked',
	NAPI_ONBOARDED_MODAL_MOUNT: 'napi.onboarded.modal.mount',
	NAPI_ONBOARDED_MODAL_UNMOUNT: 'napi.onboarded.modal.unmount',
	NAPI_USERS_MODIFIED_ONBOARDED_INFO: 'napi.users.modified.onboarded.info',
	NAPI_USERS_MODIFIED_MARKETING_INFO: 'napi.users.modified.marketing.info',
	NAPI_USERS_MODIFIED_PROFILE: 'napi.users.modified.profile',
	NAPI_USERS_CLICKED_STATIC_LINK: 'napi.users.clicked.static.link',
	NAPI_USER_IN_ACC_WITHOUT_BC_USER_ID: 'napi.user.in.acc.without.bc.user.id',
	NETWORK_ONBOARDING_API_ERROR: 'network.onboarding.api.error',
}

export default ANALYTICS_TYPES
